
import Vue from 'vue';

export default Vue.extend({
	props: {
		iconName: {
			type: String,
			default: 'Tokens SVG',
		},
		width: {
			type: [Number, String],
			default: 12,
		},
		height: {
			type: [Number, String],
			default: 12,
		},
		viewBox: {
			type: String,
			default: '0 0 12 12',
		},
		fill: {
			type: String,
			default: 'white',
		},
	},
});
